<template>
    <v-container fluid class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('menu.teamBuilding.staff') }}
        </div>

        <staff-list-view
            class="staff-list-view"
            :staffs="staffs"
            :pagination="pagination"
        />

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotal"
            @input="onPaginationChanged"
        />
    </v-container>
</template>

<script>
import StaffListView from '@/views/StaffListView'
import { getStaffs } from '@/services/mock'

export default {
    name: 'StaffListPage',

    components: {
        StaffListView
    },

    data () {
        return {
            staffs: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 6,
                itemsPerPage: 50,
                search: '',
                role: 'All Role'
            }
        }
    },

    mounted () {
        this.getMockData()
    },

    methods: {
        getMockData () {
            this.staffs = getStaffs()
        },

        onPaginationChanged (e) {
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
